
import { Component, Vue, Watch, Prop, Emit } from "vue-property-decorator"

import { AdvancedSearchFilter } from "@/types"
import { operatorLabels, operatorsByFieldType } from "@/types/insights/operators"
import { CaseColumn } from "@/types/caseColumns"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import SearchFilter from "@/components/Search/SearchFilter.vue"

@Component({
	components: {
		"search-filter": SearchFilter,
		"scrollbar": VuePerfectScrollbar
	}
})
export default class ColumnFilters extends Vue {
	@Prop()
	value!: AdvancedSearchFilter[]

	@Prop()
	public filterColumnGroups!: CaseColumn[][]

	@Prop()
	allCaseFields!: CaseColumn[];

	@Prop({ default: false })
	allowOr!: boolean

	@Prop({ default: true })
	showApply!: boolean

	private filters: AdvancedSearchFilter[] = []
	private columnFilter: string = ""
	private filtersChanged: boolean = false
	private orClauseKey: string = "or-1"

	public get filteredFieldColumnGroups (): any[][] {
		if (!this.columnFilter) {
			return this.filterColumnGroups
		}

		const lowerFilter = this.columnFilter.toLowerCase()
		return this.filterColumnGroups.map(g => g.filter((c: any) => c.label.toLowerCase().indexOf(lowerFilter) > -1))
	}

	public addFilterForColumn (column: CaseColumn) {
		const columnOperators = column.operators ? column.operators : operatorsByFieldType[column.dataType]
		const firstOperator = columnOperators && columnOperators.length > 0
			? operatorLabels.find(o => o.operator === columnOperators[0])
			: null

		this.filters.push({
			key: column.key,
			columnLabel: column.label,
			columnDataType: column.dataType,
			columnValues: column.columnValues,
			columnListLabel: column.listLabel,
			filterKey: column.filterKey,
			columnDataSource: column.dataSourceId,
			operator: firstOperator!.operator,
			operatorLabel: firstOperator!.label,
			dynamicValue: false,
			value: "",
			label: null,
			column: column
		})
	}
	public addOr () {
		this.filters.push({
			key: this.orClauseKey,
			orFilters: []
		})
	}

	public removeFilter (filter: any) {
		this.filters.splice(this.filters.indexOf(filter), 1)
	}

	@Watch("filters", { deep: true })
	filtersUpdated () {
		this.filtersChanged = true
		this.$emit("input", this.filters)
	}

	@Emit("applyFilters")
	applyFilters () {
		this.filtersChanged = false
	}
}

